import { render, staticRenderFns } from "./rightMode.vue?vue&type=template&id=53fae35e&scoped=true"
import script from "./rightMode.vue?vue&type=script&lang=js"
export * from "./rightMode.vue?vue&type=script&lang=js"
import style0 from "./rightMode.vue?vue&type=style&index=0&id=53fae35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fae35e",
  null
  
)

export default component.exports